import React, {
  useEffect,
  useState,
  createContext,
  useContext,
  ReactNode,
  FC,
} from "react";
import { useFirstModule } from "../provider/invoiceProvider";
import FirstTheme from "./firstTheme";
import SecondTheme from "./secondTheme";
import ThirdTheme from "./thirdTheme";
import FourthTheme from "./fourthTheme";
import FifthTheme from "./fifthTheme";

export type ThemeContextData = {
  invoiceLink: { link: string; order_id: string } | null;
  loading: boolean;
  updateTheme: (newData: { link?: string; order_id?: string }) => void;
};

export const FirstThemeContext = createContext<ThemeContextData>({
  invoiceLink: null,
  loading: true,
  updateTheme: () => {},
});

type LinkContextData = {
  linkData: {
    link?: string;
    app: string;
    upiId: string;
  } | null;
  loading: boolean;
  updatePaymentLink: (newData: {
    link?: string;
    app: string;
    upiId: string;
  }) => void;
};

const PaymentLinkContext = createContext<LinkContextData>({
  linkData: null,
  loading: true,
  updatePaymentLink: () => {},
});

export const FirstThemeProvider = () => {
  const { invoiceData, isSelected } = useFirstModule();
  const [themeData, setThemeData] =
    useState<ThemeContextData["invoiceLink"]>(null);

  // const [paymentLink, setPaymentLink] = useState<LinkContextData["linkData"]>({
  //   link: "",
  //   app: "",
  // });
  const [paymentLink, setPaymentLink] = useState<LinkContextData["linkData"]>({
    link: "",
    app: "",
    upiId: "",
  });

  const updatePaymentLink = (newData: // { link?: string; app: string }
  {
    link?: string;
    app: string;
    upiId: string;
  }) => {
    // setPaymentLink({
    //   link: newData.link || "",
    //   app: newData.app,
    // });
    setPaymentLink({
      link: newData.link || "",
      app: newData.app || "",
      upiId: newData?.upiId || "",
    });
  };

  const updateTheme = (newData: { link?: string; order_id?: string }) => {
    setThemeData({
      link: newData?.link || "",
      order_id: newData?.order_id || "",
    });
  };

  // useEffect(() => {
  //   if (invoiceData && isSelected) {
  //     const fetchData = async () => {
  //       try {
  //         const response = await fetch(
  //           `${process.env.REACT_APP_BACKEND_BASE_URL}/Merchent/merchantInitiateInvoiceTransaction`,
  //           {
  //             method: "POST",
  //             headers: {
  //               "Content-Type": "application/json",
  //             },
  //             body: JSON.stringify({
  //               mobileNo: invoiceData.vendor_number,
  //               amount: invoiceData.payable_amount,
  //               invoiceId: invoiceData.invoiceId,
  //             }),
  //           },
  //         );

  //         if (!response.ok) {
  //           throw new Error("API request failed");
  //         }

  //         const data = await response.json();
  //         console.log("fghjk==>", data);
  //         setThemeData({
  //           link: data.data.link,
  //           order_id: data.data.order_id,
  //         });
  //       } catch (error) {
  //         console.error("Error fetching data:", error);
  //       }
  //     };
  //     fetchData();
  //   }
  // }, [invoiceData, isSelected]);

  return (
    <div key={String(isSelected)}>
      <FirstThemeContext.Provider
        value={{ invoiceLink: themeData, loading: !themeData, updateTheme }}
      >
        <PaymentLinkContext.Provider
          value={{ linkData: paymentLink, loading: false, updatePaymentLink }}
        >
          {invoiceData?.template_id === 1 ? (
            <FirstTheme />
          ) : invoiceData?.template_id === 2 ? (
            <SecondTheme />
          ) : invoiceData?.template_id === 3 ? (
            <ThirdTheme />
          ) : invoiceData?.template_id === 4 ? (
            <FourthTheme />
          ) : invoiceData?.template_id === 5 ? (
            <FifthTheme />
          ) : null}
        </PaymentLinkContext.Provider>
      </FirstThemeContext.Provider>
    </div>
  );
};

export const useFirstTheme = () => {
  return useContext(FirstThemeContext);
};

export const usePaymentLink = () => {
  return useContext(PaymentLinkContext);
};
